import { api } from "_shared/_stores/api";
import EntityMemberSchema, { EntityMemberJSON } from "_shared/entity-members/entity-member-schema";
import z from "zod";

export const entityMemberApi = api.injectEndpoints({
  endpoints: (build) => ({
    // #region Get
    getEntityMembersByEntityId: build.query<EntityMemberJSON[], { legalEntityId: string }>({
      query: ({ legalEntityId }) => `/legal-entities/${legalEntityId}/members/`,
      rawResponseSchema: z.array(EntityMemberSchema.EntityMemberJSONZ),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ userId }) => ({ type: "EntityMember" as const, id: userId })),
              { type: "EntityMember" as const, id: "LIST" },
            ]
          : [{ type: "EntityMember" as const, id: "LIST" }],
    }),
    // #endregion
  }),
});

export const { useGetEntityMembersByEntityIdQuery } = entityMemberApi;
